/**
 * @generated SignedSource<<ba2e8ce2b68f121d87ecb98af486588b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightDetails_flight$data = {
  readonly forwardSegments: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"FlightInfo_segments">;
  }>;
  readonly returnSegments: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"FlightInfo_segments">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"FlightDetailsPrice_flight">;
  readonly " $fragmentType": "FlightDetails_flight";
};
export type FlightDetails_flight$key = {
  readonly " $data"?: FlightDetails_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightDetails_flight">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "FlightInfo_segments"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightDetails_flight",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightDetailsPrice_flight"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "forwardSegments",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "returnSegments",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "FlightType",
  "abstractKey": "__isFlightType"
};
})();

(node as any).hash = "2c04e55e6a5ff122cf7741c7f7b2df1c";

export default node;
